import { ReactNode } from 'react';

// ── ActionRow root ────────────────────────────────────────────────────────────

interface ActionRowProps {
  title: string;
  count?: number;
  description?: string;
  children?: ReactNode;
  borderBottom?: boolean;
  padding?: string;
}

function ActionRowRoot({
  title,
  count,
  description,
  children,
  borderBottom = false,
  padding = '16px 0',
}: ActionRowProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        padding,
        borderBottom: borderBottom ? '1px solid var(--evo-stroke)' : 'none',
        flexShrink: 0,
      }}
    >
      {/* Left: title + optional meta */}
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px', minWidth: 0 }}>
        <span
          style={{
            fontFamily: 'var(--evo-font)',
            fontSize: '11px',
            fontWeight: 600,
            letterSpacing: '0.88px',
            textTransform: 'uppercase',
            color: 'var(--evo-fg-3)',
            flexShrink: 0,
          }}
        >
          {title}
        </span>
        {count !== undefined && (
          <span
            style={{
              fontFamily: 'var(--evo-font)',
              fontSize: '11px',
              color: 'var(--evo-fg-3)',
              flexShrink: 0,
            }}
          >
            {count}
          </span>
        )}
        {description && (
          <span
            style={{
              fontFamily: 'var(--evo-font)',
              fontSize: '11px',
              color: 'var(--evo-fg-3)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {description}
          </span>
        )}
      </div>

      {/* Right: action buttons */}
      {children && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
          {children}
        </div>
      )}
    </div>
  );
}

// ── Export ───────────────────────────────────────────────────────────────────
// Action buttons in section headers → use SectionHeaderAction from
// packages/web/src/components/ui/SectionHeaderAction.tsx

export const ActionRow = ActionRowRoot;
